import { DashboardArticle } from './../../../models/article';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Article } from 'src/app/models/article';
import { Component, EventEmitter, Input, Output, TemplateRef, inject } from '@angular/core';

@Component({
  selector: 'app-dashboard-article-card',
  templateUrl: './dashboard-article-card.component.html',
  styleUrls: ['./dashboard-article-card.component.scss']
})
export class DashboardArticleCardComponent {
  @Input() article: DashboardArticle;
  @Input() showMutlipleImage: boolean = false;
  @Output() imageLoad = new EventEmitter<number>();

  onLoad(){
    this.imageLoad.emit(1);
  }
}
